<div class="change-password-page">
    <div class="change-password-form" *ngIf="!mailIsSended">
        <!--- Shout be disabled wishes from Zug <h2 i18n="@@landingpage.resetpassword.headline" disable-empty format-text>Info</h2>
        <p i18n="@@landingpage.resetpassword.text" disable-empty format-text>Please enter your email address.</p>-->
        <form [formGroup]="changePasswordForm" (submit)="resetPassword()">
            <validation [message]="resetError"></validation>
            <div class="form-row">
                <h2 i18n="@@landingpage.resetpassword.form.headline" disable-empty>Reset your password</h2>
                <label for="email" i18n="@@landingpage.resetpassword.label.email">E-mail address</label>
                <input name="email" id="email" value="" type="text" formControlName="email" #username [class.error]="changePasswordForm.controls.email.invalid && changePasswordForm.controls.email.touched">
                <validation [control]="changePasswordForm.controls.email">
                    <validation-message type="required" i18n="@@landingpage.resetpassword.validation.text.required">The email address cannot be empty.</validation-message>
                    <validation-message type="email" i18n="@@landingpage.resetpassword.validation.text.email">The email address you entered is invalid.</validation-message>
                </validation>
            </div>
            <div class="button-row">
                <button class="default white-spinner submit" type="submit" [attr.state]="resetPasswordButtonState" i18n="@@landingpage.resetpassword.button.resetpassword">Reset password</button>
            </div>
        </form>
    </div>
    <div class="change-password-confirmation" *ngIf="mailIsSended">
        <h2 i18n="@@landingpage.resetpassword.confirmation.headline">Reset password</h2>
        <p i18n="@@landingpage.resetpassword.confirmation.text" format-text>
            An email containing instructions on how to reset your password has been sent to your email address. Please check your emails and follow the steps described in the email.
        </p>
    </div>
</div>